import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/**
 * Component: Redirect from one URL to another without using an anchor link
 *
 * @param {*} {to}
 * @returns
 */
const Redirect = ({to}: any) => {
    const navigate = useNavigate();
    useEffect(()=>{
        navigate(to)
    }, [to])
    return null
}

export default Redirect;